import { render, staticRenderFns } from "./AudComponent.vue?vue&type=template&id=b33ce6aa&"
import script from "./AudComponent.vue?vue&type=script&lang=js&"
export * from "./AudComponent.vue?vue&type=script&lang=js&"
import style0 from "./AudComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports